import UsuarioDataService from "@/services/acessos/UsuarioDataService";
import { registerPasskey } from "@/utils/passkey";
import { getTwoFactorDeviceIdForTrust } from "@/utils/twoFactorDevice";

function defaultDeviceDescription() {
  if (typeof navigator === "undefined") {
    return "Dispositivo";
  }
  const platform = navigator.platform || "";
  if (/iphone|ipad|ios/i.test(platform)) {
    return "iOS";
  }
  if (/android/i.test(navigator.userAgent || "")) {
    return "Android";
  }
  return platform || "Navegador";
}

async function registerLegacyTrustedDevice(descricao) {
  const identificacaoDispositivo = await getTwoFactorDeviceIdForTrust({
    requestPermission: true,
  });
  await UsuarioDataService.registrarDispositivoConfiavel({
    identificacaoDispositivoAutenticacaoDoisFatores: identificacaoDispositivo,
    descricaoDispositivoAutenticacaoDoisFatores: descricao,
  });
}

export async function askAndRegisterTrustedDevice(vm) {
  if (!vm || !vm.$swal) {
    return;
  }

  const result = await vm.$swal.fire({
    title: vm.$t("Confiar_neste_dispositivo"),
    text: vm.$t("Confiar_dispositivo_apos_login"),
    input: "text",
    inputLabel: vm.$t("Descricao_dispositivo"),
    inputValue: defaultDeviceDescription(),
    inputAttributes: {
      maxlength: 120,
      autocapitalize: "off",
      autocorrect: "off",
    },
    showCancelButton: true,
    confirmButtonText: vm.$t("Confiar_neste_dispositivo"),
    cancelButtonText: vm.$t("Cancelar"),
    inputValidator: (value) => {
      if (!String(value || "").trim()) {
        return vm.$t("Informe_descricao_dispositivo");
      }
      return undefined;
    },
  });

  if (!result.isConfirmed) {
    return;
  }

  try {
    const descricao = String(result.value || "")
      .trim()
      .slice(0, 120);
    let passkey = null;
    try {
      passkey = await registerPasskey(descricao);
    } catch (error) {
      passkey = null;
    }
    if (!passkey) {
      await registerLegacyTrustedDevice(descricao);
    }
    await vm.$swal.fire(
      vm.$t("Sucesso"),
      vm.$t("Dispositivo_confiavel_registrado"),
      "success"
    );
  } catch (error) {
    await vm.$swal.fire(
      vm.$t("Erro"),
      vm.$t("Nao_foi_possivel_registrar_dispositivo_confiavel"),
      "error"
    );
  }
}
